import React, { useEffect, useState } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
} from "../../../partials/controls";
import "react-quill/dist/quill.snow.css";
import { useFormik } from "formik";
import * as Yup from "yup";
import { api } from "../../../common/api";
import { toast } from "react-toastify";
import SearchSelect from "react-select";

interface Values {
  name: string;
  password: string;
  displayName: string;
  status: string;
  siteIds: any;
}
interface Params {
  id?: string;
}
const AddMO = () => {
  const params: Params = useParams();
  const history = useHistory();

  const [editEntities, setEditEntities] = useState<any>();
  const [sites, setSites] = useState<any>([]);

  const getMOData = async () => {
    try {
      const { data }: any = await api({
        url: `/user/details/${params.id}`,
        method: "get",
      });
      if (data.serverResponse.isError) {
        toast.error(data.serverResponse.message);
      } else {
        let item: any = data.result.data;
        setEditEntities({
          ...item,
          status: item.isActive ? "Active" : "Inactive",
          siteIds: [], // Will be set after sites are loaded
          siteIdsRaw: item.siteIds || [], // Store raw siteIds from API
        });
      }
    } catch (err) {
      // @ts-ignore
      err.response && toast.error(err.message);
    }
  };

  const getSites = async () => {
    try {
      const { data }: any = await api({
        url: `/site/list`,
        method: "get",
      });
      if (data.serverResponse.isError) {
        toast.error(data.serverResponse.message);
      } else {
        setSites(data.result.data.siteData.filter((site: any) => site.isActive));
      }
    } catch (err) {
      // @ts-ignore
      err.response && toast.error(err.message);
    }
  };

  useEffect(() => {
    const initializeData = async () => {
      if (params.id) {
        await getMOData();
      }
      await getSites();
    };

    initializeData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Convert siteIdsRaw to full site objects when both are loaded
  useEffect(() => {
    if (editEntities?.siteIdsRaw && sites.length > 0) {
      const siteObjects = editEntities.siteIdsRaw
        .map((siteId: string) => sites.find((site: any) => site._id === siteId))
        .filter((site: any) => site); // Filter out undefined values

      setEditEntities((prev: any) => ({
        ...prev,
        siteIds: siteObjects,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editEntities?.siteIdsRaw, sites]);

  const AddMOData = async (values: Values) => {
    let body = {
      name: values.name,
      password: values.password,
      displayName: values.displayName,
      siteIds: values.siteIds?.map((site: any) => site._id) || [],
    };
    try {
      const { data }: any = await api({
        url: `/user/mo/register`,
        method: "post",
        body,
      });
      if (data.serverResponse.isError) {
        toast.error(data.serverResponse.message);
      } else {
        toast.success("Data added successfully");
        history.push("/mo");
      }
    } catch (err) {
      // @ts-ignore
      err.response && toast.error(err.message);
    }
  };

  const UpdateMOData = async (values: Values) => {
    let body = {
      name: values.name,
      displayName: values.displayName,
      isActive: values.status,
      siteIds: values.siteIds?.map((site: any) => site._id) || [],
    };
    try {
      const { data }: any = await api({
        url: `/user/mo/update/${params.id}`,
        method: "put",
        body,
      });
      if (data.serverResponse.isError) {
        toast.error(data.serverResponse.message);
      } else {
        toast.success("Data updated successfully");
        history.push("/mo");
      }
    } catch (err) {
      // @ts-ignore
      err.response && toast.error(err.message);
    }
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: params.id ? editEntities && editEntities?.name : "",
      displayName: params.id ? editEntities && editEntities?.displayName : "",
      password: params.id ? editEntities && editEntities?.password : "",
      status: params.id ? editEntities && editEntities?.isActive : true,
      siteIds: params.id ? editEntities && editEntities?.siteIds : [],
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Name is required"),
      displayName: Yup.string().required("Display Name is required"),
      password: Yup.string().required("Password Code is required"),
      status: Yup.string().required("Status is required"),
    }),
    onSubmit: (values: Values) => {
      params.id ? UpdateMOData(values) : AddMOData(values);
    },
  });

  return (
    <div>
      <Card>
        <CardHeader title={params.id ? "Edit MO" : "Add MO"}></CardHeader>
        <CardBody>
          <div className="row">
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="row">
                <div className="col-lg-4 ws-nowrap">Username</div>
                <div className="col-lg-8">
                  {" "}
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      id="name"
                      name="name"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.name || ""}
                    />
                    {formik.touched.name && formik.errors.name ? (
                      <div className="text-danger mt-1 ml-1">
                        {formik.errors.name}
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>

            {!params.id ? (
              <div className="col-lg-6 col-md-6 col-sm-12">
                <div className="row">
                  <div className="col-lg-4 ws-nowrap">Password</div>
                  <div className="col-lg-8">
                    {" "}
                    <div className="form-group">
                      <input
                        type="text"
                        className="form-control"
                        id="password"
                        name="password"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.password || ""}
                      />
                      {formik.touched.password && formik.errors.password ? (
                        <div className="text-danger mt-1 ml-1">
                          {formik.errors.password}
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
          <div className="row">
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="row">
                <div className="col-lg-4 ws-nowrap">Dispaly Name</div>
                <div className="col-lg-8">
                  {" "}
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      id="displayName"
                      name="displayName"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.displayName || ""}
                    />
                    {formik.touched.displayName && formik.errors.displayName ? (
                      <div className="text-danger mt-1 ml-1">
                        {formik.errors.displayName}
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="row">
                <div className="col-lg-4 ws-nowrap">Sites</div>
                <div className="col-lg-8">
                  <div className="form-group">
                    <SearchSelect
                      isMulti
                      name="siteIds"
                      value={formik.values.siteIds}
                      onChange={(value: any) => formik.setFieldValue("siteIds", value)}
                      options={sites}
                      getOptionLabel={(option: any) => option.name}
                      getOptionValue={(option: any) => option._id}
                      placeholder="Select sites..."
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {params.id ? (
            <div className="row">
              <div className="col-lg-6 col-md-6 col-sm-12">
                <div className="row">
                  <div className="col-lg-4 ws-nowrap">Status</div>
                  <div className="col-lg-8">
                    <div className="form-group">
                      <select
                        className="form-control"
                        id="status"
                        name="status"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.status}
                      >
                        <option value="true">Active</option>
                        <option value="false">Inactive</option>
                      </select>
                      {formik.touched.status && formik.errors.status ? (
                        <div className="text-danger mt-1 ml-1">
                          {formik.errors.status}
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            ""
          )}
        </CardBody>
        <CardFooter>
          <div className="d-flex flex-wrap align-items-center justify-content-between">
            <div className="mt-4 mt-sm-0">
              <Link className="btn btn-primary" to="/mo">
                Back
              </Link>
            </div>
            <div className="mt-4 mt-sm-0">
              <button
                type="submit"
                className="btn btn-success mr-2 mx-sm-2"
                onClick={() => formik.handleSubmit()}
              >
                {params?.id ? "Save" : "Add"}
              </button>
            </div>
          </div>
        </CardFooter>
      </Card>
    </div>
  );
};

export default AddMO;
